<template>
    <main class="client-edit-page" v-loading="loading">
        <section class="client-edit-card">
            <header class="client-edit-header">
                <div class="client-edit-title">
                    <el-button class="client-back-button" icon="el-icon-arrow-left"
                               @click.native.prevent="goBack"></el-button>
                    <h1>{{$t('clientCreate.pageTitle')}}</h1>
                </div>
                <el-button class="client-save-button" type="primary" :disabled="company == null || loading || buttonDisabledStatus"
                           @click.native.prevent="createClient">{{$t('common.save')}}</el-button>
            </header>

            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <el-form v-else-if="company != null" class="client-modern-form" label-width="0px" :model="objectModel" :rules="validRules"
                     ref="objectModel">
                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-user client-section-icon"></i>
                            <span>{{$t('clientCreate.basicInformation')}}</span>
                        </div>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row" prop="name">
                            <span class="client-form-label">{{$t('clientCreate.labelName')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.name"
                                      :placeholder="$t('clientCreate.placeholderName')"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row" prop="clientEmail">
                            <span class="client-form-label">{{$t('clientCreate.labelEmail')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.clientEmail"

                                      :placeholder="$t('clientCreate.placeholderEmail')"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelPhone')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.phone"
                                      :placeholder="$t('clientCreate.placeholderPhone')"></el-input>
                        </el-form-item>
                    </div>
                </section>

                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-document client-section-icon"></i>
                            <span>{{$t('clientCreate.billingAddress')}}</span>
                        </div>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine1')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine1"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine2')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine2"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelLine3')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.billingAddressLine3"></el-input>
                        </el-form-item>
                    </div>
                </section>

                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-location-outline client-section-icon"></i>
                            <span>{{$t('clientCreate.shippingAddress')}}</span>
                        </div>
                        <el-checkbox v-model="sameAsBilling" class="client-same-checkbox">{{$t('clientCreate.sameAsBilling')}}</el-checkbox>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingName')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingName"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine1')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine1"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine2')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine2"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                        <el-form-item class="client-form-row">
                            <span class="client-form-label">{{$t('clientCreate.labelShippingLine3')}}</span>
                            <el-input class="client-line-input" v-model="objectModel.shippingAddressLine3"
                                      :disabled="sameAsBilling"></el-input>
                        </el-form-item>
                    </div>
                </section>

                <section class="client-form-section">
                    <div class="client-section-header">
                        <div class="client-section-title">
                            <i class="el-icon-discount client-section-icon"></i>
                            <span>{{$t('clientCreate.defaultDiscount')}}</span>
                        </div>
                    </div>
                    <div class="client-section-content">
                        <el-form-item class="client-form-row client-discount-row" prop="itemDiscount">
                            <span class="client-form-label">{{$t('clientCreate.defaultDiscount')}}</span>
                            <div class="client-discount-control">
                                <el-radio-group class="client-discount-type"
                                                v-model="objectModel.itemDiscountAsPercent" size="small">
                                    <el-radio-button :label="0">$</el-radio-button>
                                    <el-radio-button :label="1">%</el-radio-button>
                                </el-radio-group>
                                <el-input class="client-line-input client-discount-input"
                                          inputmode="decimal" v-model="objectModel.itemDiscount"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item class="client-form-row client-note-row">
                            <span class="client-form-label">{{$t('clientCreate.labelNotes')}}</span>
                            <el-input class="client-line-textarea" type="textarea" autosize v-model="objectModel.note"
                                      :placeholder="$t('clientCreate.placeholderNotes')"></el-input>
                        </el-form-item>
                    </div>
                </section>
            </el-form>
        </section>
    </main>
</template>

<script>
    import {uuid, timest, validateEmail} from '@/utils/validate'
    import {syncCompanySelection} from '@/utils/company'

    export default {
        data() {
            const validEmail = (rule, value, callback) => {
                if (value.length > 0 && !validateEmail(value)) {
                    callback(new Error(this.$t('clientCreate.validEmail')))
                } else {
                    callback()
                }
            }
            const validDefaultDiscount = (rule, value, callback) => {
                const valueText = String(value).trim();
                const discount = Number(valueText);
                const decimalFormat = /^(?:\d+\.?\d*|\.\d+)$/;
                const fractionLength = valueText.includes('.') ? valueText.split('.')[1].length : 0;
                const maxFractionLength = this.objectModel.itemDiscountAsPercent === 1 ? 3 : 5;
                const maxDiscount = this.objectModel.itemDiscountAsPercent === 1 ? 100 : 999999999999999;
                if (
                    valueText.length === 0 ||
                    !decimalFormat.test(valueText) ||
                    !Number.isFinite(discount) ||
                    discount < 0 ||
                    discount > maxDiscount ||
                    fractionLength > maxFractionLength
                ) {
                    callback(new Error(this.$t('clientCreate.validDefaultDiscount')))
                } else {
                    callback()
                }
            }
            return {
                objectModel: {
                    name: '',
                    clientEmail: '',
                    phone: '',
                    billingAddressLine1: '',
                    billingAddressLine2: '',
                    billingAddressLine3: '',
                    shippingName: '',
                    shippingAddressLine1: '',
                    shippingAddressLine2: '',
                    shippingAddressLine3: '',
                    itemDiscount: 0,
                    itemDiscountAsPercent: 0,
                    note: ''
                },
                sameAsBilling: false,
                company: null,
                loading: true,
                loadError: '',
                buttonDisabledStatus: true,
                validRules: {
                    clientEmail: [{trigger: ['blur', 'change'], validator: validEmail}],
                    itemDiscount: [{trigger: ['blur', 'change'], validator: validDefaultDiscount}],
                }
            }
        },
        watch: {
            sameAsBilling(value) {
                if (value) {
                    this.syncShippingAddress();
                }
            },
            'objectModel.billingAddressLine1'() {
                this.syncShippingAddressIfNeeded();
            },
            'objectModel.billingAddressLine2'() {
                this.syncShippingAddressIfNeeded();
            },
            'objectModel.billingAddressLine3'() {
                this.syncShippingAddressIfNeeded();
            }
        },
        methods: {
            async loadPage() {
                this.loading = true;
                this.loadError = '';
                this.buttonDisabledStatus = true;
                try {
                    const response = await this.$axios.post('query_setting_and_company', {params: {}});
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.company = selectedData.company;
                    this.buttonDisabledStatus = false;
                } catch {
                    this.loadError = this.$t('common.loadFailed');
                } finally {
                    this.loading = false;
                }
            },
            syncShippingAddressIfNeeded() {
                if (this.sameAsBilling) {
                    this.syncShippingAddress();
                }
            },
            syncShippingAddress() {
                this.objectModel.shippingAddressLine1 = this.objectModel.billingAddressLine1;
                this.objectModel.shippingAddressLine2 = this.objectModel.billingAddressLine2;
                this.objectModel.shippingAddressLine3 = this.objectModel.billingAddressLine3;
            },
            storedDefaultDiscount() {
                const discount = Number(this.objectModel.itemDiscount);
                return this.objectModel.itemDiscountAsPercent === 1
                    ? this.$NP.divide(discount, 100)
                    : discount;
            },
            goBack() {
                let self = this;
                self.$router.push('/client');
            },
            createClient() {
                if (this.company == null || this.loading || this.buttonDisabledStatus) {
                    return;
                }
                let self = this;
                this.objectModel.name = String(this.objectModel.name == null ? '' : this.objectModel.name).trim();
                this.$refs.objectModel.validate((valid) => {
                    if (valid) {
                        const clientUUID = uuid(null, 37);
                        this.loading = true;
                        this.buttonDisabledStatus = true;
                        this.$axios.post('create_user_client', {
                            params: {
                                name: this.objectModel.name,
                                clientEmail: this.objectModel.clientEmail,
                                phone: this.objectModel.phone,
                                billingAddressLine1: this.objectModel.billingAddressLine1,
                                billingAddressLine2: this.objectModel.billingAddressLine2,
                                billingAddressLine3: this.objectModel.billingAddressLine3,
                                shippingName: this.objectModel.shippingName,
                                shippingAddressLine1: this.objectModel.shippingAddressLine1,
                                shippingAddressLine2: this.objectModel.shippingAddressLine2,
                                shippingAddressLine3: this.objectModel.shippingAddressLine3,
                                note: this.objectModel.note,
                                innerUUID: clientUUID,
                                companyUUID: this.company.innerUUID,
                                createDate: timest(),
                                accessDate: timest(),
                                cell:"",
                                contact:"",
                                fax:"",
                                pager:"",
                                website:"",
                                itemDiscount: this.storedDefaultDiscount(),
                                itemDiscountAsPercent: this.objectModel.itemDiscountAsPercent,
                                isDelete: 0,
                                syncStatus: 0
                            }
                        }).then(response => {
                            if (response.data.errorCode !== 0
                                || response.data.objectData == null
                                || response.data.objectData.innerUUID !== clientUUID
                                || response.data.objectData.companyUUID !== this.company.innerUUID) {
                                throw new Error('Client create failed');
                            }
                            self.$router.push('/client');
                        }).catch(function () {
                            self.$message.error(self.$t('common.saveFailed'));
                        }).finally(function () {
                            self.loading = false;
                            self.buttonDisabledStatus = false;
                        })
                    } else {
                        return false;
                    }
                });
            }
        },
        mounted() {
            this.loadPage();
        }
    }
</script>
